<template>
  <v-sheet class="grey lighten-5 py-6 px-3 px-md-12" min-height="calc(100% - 180px)">
    <h1 class="text-center mb-8 headline">{{ titre(facture, payable) }}</h1>
    <v-row v-if="payable">
      <v-col md="8" sm="12" xs="12">
        <AlerteFacture v-if="showAlert && $vuetify.breakpoint.mobile" :facture="facture" />
        <InfosFacture :facture="facture" :formatDate="formatDate" class="mb-4" />
        <DetailsFacture :facture="facture" :formatPrix="formatPrix" :formatRabais="formatRabais" :formatQuantite="formatQuantite" payable />
      </v-col>
      <v-col md="4" sm="12" xs="12">
        <AlerteFacture v-if="showAlert && !$vuetify.breakpoint.mobile" :facture="facture" />
        <EcheancierFacture :listeEcheanciers="facture.listeEcheanciers" :formatPrix="formatPrix" v-if="facture.nbEcheanciers > 1" class="mb-4" />
        <PaiementFacture :inputFields="inputFields" :formatPrix="formatPrix" @payerClicked="payerClicked" :facture="facture">
          <template v-slot:btn-paiement>
            <slot name="btn-paiement"></slot>
          </template>
        </PaiementFacture>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col md="12" sm="12" xs="12">
        <AlerteFacture v-if="showAlert" :facture="facture" @deleteCard="deleteCard" />
        <InfosFacture :facture="facture" :formatDate="formatDate" class="mb-4" />
        <DetailsFacture :facture="facture" :formatPrix="formatPrix" :formatRabais="formatRabais" :formatQuantite="formatQuantite" class="mb-4" />
        <EcheancierFacture :listeEcheanciers="facture.listeEcheanciers" :formatPrix="formatPrix" v-if="facture.nbEcheanciers > 1" class="mb-4" />
        <SupprimerCartePaiementRecurrent v-if="isCardDeletable" :enabled="!payable && this.isCardDeletable" :idFacture="idFacture" @cardDeleted="cardDeleted" class="mb-4" ref="supprimerCartePaiementRecurrent" />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
import InfosFacture from "./InfosFacture"
import DetailsFacture from "./DetailsFacture"
import PaiementFacture from "./PaiementFacture"
import AlerteFacture from "./AlerteFacture"
import EcheancierFacture from "./EcheancierFacture"
import SupprimerCartePaiementRecurrent from "./SupprimerCartePaiementRecurrent.vue"

export default {
  components: {
    InfosFacture,
    DetailsFacture,
    PaiementFacture,
    AlerteFacture,
    EcheancierFacture,
    SupprimerCartePaiementRecurrent
  },
  props: {
    facture: Object,
    inputFields: {
      type: Boolean,
      default: false
    },
    showAlert: {
      type: Boolean,
      default: true
    },
    titre: {
      type: Function,
      default: (facture, payable) => {
        if (payable) {
          return "Résumé " + facture.reference
        }
        return "Reçu de paiement " + facture.reference
      }
    },
    formatPrix: {
      type: Function,
      default: (montant) => {
        let val = (montant / 1).toFixed(2).replace(".", ",")
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " $"
      }
    },
    formatDate: {
      type: Function,
      default: (date) => {
        var options = {
          year: "numeric",
          month: "2-digit",
          day: "2-digit"
        }
        var locale = "fr-CA"
        return new Date(date).toLocaleString(locale, options)
      }
    },
    formatQuantite: {
      type: Function,
      default: (quantite) => {
        let val = (quantite / 1).toFixed(0)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
      }
    },
    formatRabais :{
      type: Function,
      default: (montant, type) => {
        return this.formatMoney(montant) + ((type == 'pourcentage') ? ' %' : ' $')
      }
    },
    payable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    idFacture() {
      return this.$route.params.idFacture
    },
    // Détermine l'affichage du composant permettant de supprimer la carte du paiement récurrent.
    isCardDeletable() {
      return this.facture && 
        this.facture.jetonDeFacturation && 
        this.facture.solde > 0 && 
        this.facture.dejaPaye < this.facture.total && 
        this.facture.nbEcheanciers > 0 && 
        this.facture.carteSupprimable;
    }
  },
  methods: {
    payerClicked(carte) {
      this.$emit("payerClicked", carte)
    },
    // Notifie le composant parent de se rafraichir lors de la suppression de la carte.
    cardDeleted() {
      this.$emit("cardDeleted")
    },
    // Appelle le composant enfant de suppression de carte depuis le lien d'AlerteFacture.
    deleteCard() {
      this.$refs.supprimerCartePaiementRecurrent.supprimerCarteClicked();
    }
  }
}
</script>

<style scoped></style>